import React from 'react';
import * as yup from 'yup';
import StandardInput from '@@/components/Inputs/StandardInput';
import SelectPatientInput from '@@/components/Inputs/SelectPatientInput';

export const schema = yup
  .object({
    patientId: yup.object({
      id: yup.string(),
      label: yup.string(),
    }),
    CUSTOM__CHIEF_COMPLAINT: yup.string(),
    CUSTOM__DESEASE_HISTORY: yup.string(),
    CUSTOM__MEDICAL_HISTORY: yup.string(),
    CUSTOM__SURGICAL_HISTORY: yup.string(),
    CUSTOM__FAMILY_HISTORY: yup.string(),
    CUSTOM__LIFESTYLE: yup.string(),
    CUSTOM__CURRENT_TREATMENTS: yup.string(),
    CUSTOM__COMPLEMENTARY_EXAMS: yup.string(),
    CUSTOM__ASSESSMENT: yup.string(),
    CUSTOM__PLAN: yup.string(),
  })
  .required();

const EncounterNoteForm: React.FC<{
  form: any;
}> = ({ form }) => {
  const {
    register,
    formState: { errors },
  } = form;

  const [patientId] = form.watch(['patientId']);

  return (
    <div>
      <div className="w-[300px] mb-14">
        <SelectPatientInput
          control={form.control}
          values={patientId}
          id="patientId"
          label="Patient"
          placeholder="Choisissez un patient"
        />
      </div>

      <div className="mt-8 grid grid-cols-1 gap-10">
        <StandardInput
          register={register}
          id="CUSTOM__CHIEF_COMPLAINT"
          label="Motif de consultation"
          type="textarea"
          placeholder="Motif de consultation"
          error={errors.CUSTOM__CHIEF_COMPLAINT}
        />
        <StandardInput
          register={register}
          id="CUSTOM__DESEASE_HISTORY"
          label="Histoire de la maladie"
          type="textarea"
          placeholder="Histoire de la maladie"
          error={errors.CUSTOM__DESEASE_HISTORY}
        />
        <StandardInput
          register={register}
          id="CUSTOM__MEDICAL_HISTORY"
          label="Antécédents médicaux"
          type="textarea"
          placeholder="Antécédents médicaux"
          error={errors.CUSTOM__MEDICAL_HISTORY}
        />
        <StandardInput
          register={register}
          id="CUSTOM__SURGICAL_HISTORY"
          label="Antécédents chirurgicaux"
          type="textarea"
          placeholder="Antécédents chirurgicaux"
          error={errors.CUSTOM__SURGICAL_HISTORY}
        />
        <StandardInput
          register={register}
          id="CUSTOM__FAMILY_HISTORY"
          label="Antécédents familiaux"
          type="textarea"
          placeholder="Antécédents familiaux"
          error={errors.CUSTOM__FAMILY_HISTORY}
        />
        <StandardInput
          register={register}
          id="CUSTOM__LIFESTYLE"
          label="Mode de vie"
          type="textarea"
          placeholder="Mode de vie"
          error={errors.CUSTOM__LIFESTYLE}
        />
        <StandardInput
          register={register}
          id="CUSTOM__CURRENT_TREATMENTS"
          label="Traitement(s) en cours"
          type="textarea"
          placeholder="Traitement(s) en cours"
          error={errors.CUSTOM__CURRENT_TREATMENTS}
        />
        <StandardInput
          register={register}
          id="CUSTOM__COMPLEMENTARY_EXAMS"
          label="Examens complémentaires"
          type="textarea"
          placeholder="Examens complémentaires"
          error={errors.CUSTOM__COMPLEMENTARY_EXAMS}
        />
        <StandardInput
          register={register}
          id="CUSTOM__ASSESSMENT"
          label="Contexte et évaluation"
          type="textarea"
          placeholder="Contexte et évaluation"
          error={errors.CUSTOM__ASSESSMENT}
        />
        <StandardInput
          register={register}
          id="CUSTOM__PLAN"
          label="Recommandations"
          type="textarea"
          placeholder="Recommandations"
          error={errors.CUSTOM__PLAN}
        />
      </div>
    </div>
  );
};

export default EncounterNoteForm;
